module.exports = __webpack_public_path__ + "static/media/marco-marine.eb380a5b.webp";